import { defineStyleConfig } from "@chakra-ui/react";

const FormLabel = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    marginBottom: "var(--chakra-space-2)",
    fontWeight: "var(--chakra-fontWeights-bold)",
    fontSize: "medium",
  },
});

export default FormLabel;
